import Svg, { Circle, Path, Rect } from 'react-native-svg';

interface BrandIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function LinkedinIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
}: Readonly<BrandIconProps>) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <Rect width="4" height="12" x="2" y="9" />
      <Circle cx="4" cy="4" r="2" />
    </Svg>
  );
}

export function FacebookIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
}: Readonly<BrandIconProps>) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </Svg>
  );
}

export function InstagramIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
}: Readonly<BrandIconProps>) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <Path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <Path d="M17.5 6.5h.01" />
    </Svg>
  );
}

export function TwitterIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
}: Readonly<BrandIconProps>) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
    </Svg>
  );
}
